<template>
  <div class="bg-custom">
    <v-row>
      <v-col cols="12" class="px-0 pt-0">
        <v-sheet color="white" class="pa-2">
          <div class="px-6 pb-5">
            <v-card-actions class="pa-0">
              <h2>{{ $vuetify.lang.t('$vuetify.company.companyDetail') }}</h2>
            </v-card-actions>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <v-form
      ref="form"
      v-model="valid"
      v-on:submit.prevent="onUpload"
      class="px-5 py-3"
    >
      <v-sheet color="white" class="mb-3 pa-6">
        <v-row>
          <v-col lg="6" md="6" sm="6" cols="12">
            <p class="mb-2 body-1 font-weight-medium text-custom-title">
              {{ $vuetify.lang.t('$vuetify.company.companyName') }}
              <span class="red--text">*</span>
            </p>
            <v-text-field
              outlined
              v-model="title"
              :rules="companyNameRules"
              :placeholder="$vuetify.lang.t('$vuetify.company.companyName')"
              required
              clearable
              background-color="white"
            ></v-text-field>
            <p class="mb-2 body-1 font-weight-medium text-custom-title">
              {{ $vuetify.lang.t('$vuetify.company.description') }}
            </p>
            <quill-editor
              class="mb-5 editor detail-editor"
              v-model="description"
              ref="description"
              :value="description"
              :options="editorOption"
              @change="onEditorChange"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
            />
          </v-col>

          <v-col lg="6" md="6" sm="6" cols="12">
            <!--
            <p class="mb-2 body-1 font-weight-medium text-custom-title">
              {{ $vuetify.lang.t('$vuetify.company.systemEmail') }}
              <span class="red--text">*</span>
              <span class="grey--text ml-3"
                >({{ $vuetify.lang.t('$vuetify.company.msg1') }} )</span
              >
            </p>
            <v-text-field
              v-model="systemEmail"
              outlined
              :counter="50"
              :rules="emailRules"
              :placeholder="$vuetify.lang.t('$vuetify.company.msg1')"
              required
              clearable
              background-color="white"
            ></v-text-field>
-->
            <p class="mb-2 body-1 font-weight-medium text-custom-title">
              {{ $vuetify.lang.t('$vuetify.company.contactEmail') }}
              <span class="red--text">*</span>
            </p>
            <v-text-field
              v-model="contactEmail"
              outlined
              :rules="emailRules"
              :counter="50"
              :placeholder="$vuetify.lang.t('$vuetify.company.contactEmail')"
              clearable
              background-color="white"
            >
            </v-text-field>

            <p class="mb-2 body-1 font-weight-medium text-custom-title">
              {{ $vuetify.lang.t('$vuetify.company.subDomain') }}
              <span class="red--text">*</span>
            </p>
            <v-text-field
              v-model="domainName"
              disabled
              outlined
              :placeholder="$vuetify.lang.t('$vuetify.company.subDomain')"
              :rules="domainNameRule"
              required
              clearable
              background-color="white"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-sheet>

      <v-row>
        <v-col lg="6" md="6" sm="6" cols="12">
          <v-card elevation="0" width="100%" tile>
            <v-card-title
              ><p class="title font-weight-black mb-0">
                {{ $vuetify.lang.t('$vuetify.company.Limitation') }}
              </p></v-card-title
            >
            <v-divider></v-divider>
            <v-card-text>
              <p class="mb-2 body-1 font-weight-black">
                {{ $vuetify.lang.t('$vuetify.company.externalAccess') }}
                <span class="red--text">*</span>
              </p>
              <v-radio-group v-model="externalAccess" column>
                <v-radio :value="false">
                  <template v-slot:label>
                    <div>
                      <span class="dark--text">{{
                        $vuetify.lang.t('$vuetify.company.externalAccessNo')
                      }}</span>
                      <span class="grey--text ml-3"
                        >({{ $vuetify.lang.t('$vuetify.company.msg2') }})</span
                      >
                    </div>
                  </template>
                </v-radio>
                <v-radio :value="true">
                  <template v-slot:label>
                    <div>
                      <span class="dark--text">{{
                        $vuetify.lang.t('$vuetify.company.externalAccessYes')
                      }}</span>
                      <span class="grey--text ml-3"
                        >({{ $vuetify.lang.t('$vuetify.company.msg3') }})</span
                      >
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>

              <p class="mb-2 body-1 font-weight-black">
                {{ $vuetify.lang.t('$vuetify.company.allowRegister') }}
                <span class="red--text">*</span>
              </p>
              <v-radio-group v-model="canRegister" column>
                <v-radio :value="false">
                  <template v-slot:label>
                    <div>
                      <span class="dark--text">
                        {{
                          $vuetify.lang.t('$vuetify.company.allowRegisterNo')
                        }}</span
                      >
                      <span class="grey--text ml-3"
                        >({{ $vuetify.lang.t('$vuetify.company.msg4') }})</span
                      >
                    </div>
                  </template>
                </v-radio>
                <v-radio :value="true">
                  <template v-slot:label>
                    <div>
                      <span class="dark--text">{{
                        $vuetify.lang.t('$vuetify.company.allowRegisterYes')
                      }}</span>
                      <span class="grey--text ml-3"
                        >({{ $vuetify.lang.t('$vuetify.company.msg5') }})</span
                      >
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>

              <!-- <div v-show="canRegister">
              <p class="mt-2 mb-3 body-1 font-weight-black">
                {{ $vuetify.lang.t('$vuetify.company.registerOption') }}
              </p>
              <v-checkbox
                class="mt-0"
                :label="$vuetify.lang.t('$vuetify.company.registerOptionEmail')"
                v-model="loginEmail"
              ></v-checkbox>
              <v-checkbox
                class="mt-0"
                :label="
                  $vuetify.lang.t('$vuetify.company.registerOptionFacebook')
                "
                v-model="loginFacebook"
                disabled
              ></v-checkbox>
              <v-checkbox
                class="mt-0"
                :label="$vuetify.lang.t('$vuetify.company.registerOptionGmail')"
                v-model="loginGoogle"
                disabled
              ></v-checkbox>
              </div> -->
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="6" cols="12">
          <v-card elevation="0" width="100%" tile>
            <v-card-title>
              <p class="title font-weight-black mb-0">
                {{ $vuetify.lang.t('$vuetify.company.customizePhoto') }}
              </p>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="6" class="pt-0">
                  <p class="mb-2 body-1 font-weight-black">
                    {{ $vuetify.lang.t('$vuetify.company.landscapeImage') }}
                    <span class="red--text">*</span>
                  </p>
                  <div v-if="coverImgReady" class="image-preview border-card">
                    <v-img
                      contain
                      :src="coverImg"
                      aspect-ratio="1"
                      width="100%"
                      height="100%"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>
                  <div v-if="!coverImgReady" class="image-preview border-card">
                    <v-img
                      contain
                      src="../../assets/placeholder-image.png"
                      aspect-ratio="1"
                      width="100%"
                      height="100%"
                    ></v-img>
                  </div>
                  <div class="upload-btn-wrapper mt-3">
                    <button class="btn-choose body-1 font-weight-medium">
                      <v-icon>mdi-upload</v-icon
                      >{{ $vuetify.lang.t('$vuetify.company.chooseFile') }}
                    </button>
                    <input
                      type="file"
                      name="myfile"
                      :rules="imageRules"
                      @change="previewCoverImg"
                      accept="image/png, image/jpeg, image/bmp"
                    />
                  </div>
                  <p class="mb-0 text-custom body-2 font-weight-regular">
                    {{ $vuetify.lang.t('$vuetify.company.msg6') }}
                  </p>
                  <p class="mb-0 text-custom body-2 font-weight-regular">
                    {{ $vuetify.lang.t('$vuetify.company.msg7') }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0">
                  <p class="mb-2 body-1 font-weight-black">
                    {{ $vuetify.lang.t('$vuetify.company.squareImage') }}
                    <span class="red--text">*</span>
                  </p>
                  <div v-if="logoReady" class="image-preview-logo border-card">
                    <v-img contain :src="logo" width="100%" height="100%">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>
                  <div v-if="!logoReady" class="image-preview-logo border-card">
                    <v-img
                      contain
                      src="../../assets/placeholder-image.png"
                      aspect-ratio="1"
                      width="100%"
                      height="100%"
                    ></v-img>
                  </div>
                  <div class="upload-btn-wrapper mt-3">
                    <button class="btn-choose body-1 font-weight-medium">
                      <v-icon>mdi-upload</v-icon
                      >{{ $vuetify.lang.t('$vuetify.company.chooseFile') }}
                    </button>
                    <input
                      type="file"
                      name="myfile"
                      :rules="imageRules"
                      @change="previewLogo"
                      accept="image/png, image/jpeg, image/bmp"
                    />
                  </div>
                  <p class="mb-0 text-custom body-2 font-weight-regular">
                    {{ $vuetify.lang.t('$vuetify.company.msg6') }}
                  </p>
                  <p class="mb-0 text-custom body-2 font-weight-regular">
                    {{ $vuetify.lang.t('$vuetify.company.msg7') }}
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="12" md="12" sm="12" cols="12">
          <v-card elevation="0" width="100%" tile>
            <v-card-title
              ><p class="title font-weight-black mb-0">
                {{ $vuetify.lang.t('$vuetify.company.customizeColor') }}
              </p></v-card-title
            >
            <v-divider></v-divider>
            <v-card-text>
              <v-row class="px-3">
                <v-col lg="3" md="3" sm="3" cols="12">
                  <v-card
                    class="mx-auto"
                    max-width="400"
                    outlined
                    @click="overallOnClick"
                  >
                    <v-list-item two-line>
                      <v-list-item-avatar tile>
                        <v-sheet
                          :color="overall"
                          elevation="0"
                          height="100"
                          width="100"
                        ></v-sheet>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          class="font-weight-bold text-uppercase"
                          >{{
                            $vuetify.lang.t('$vuetify.company.themeColor')
                          }}</v-list-item-title
                        >
                        <v-list-item-subtitle>{{
                          showOverallColor
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-col>
                <v-col lg="3" md="3" sm="3" cols="12">
                  <v-card
                    class="mx-auto"
                    max-width="400"
                    outlined
                    @click="headerOnClick"
                  >
                    <v-list-item two-line>
                      <v-list-item-avatar tile>
                        <v-sheet
                          :color="header"
                          elevation="0"
                          height="100"
                          width="100"
                        ></v-sheet>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          class="font-weight-bold text-uppercase"
                          >{{
                            $vuetify.lang.t('$vuetify.company.headerColor')
                          }}</v-list-item-title
                        >
                        <v-list-item-subtitle>{{
                          showHeaderColor
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-col>
                <v-col lg="3" md="3" sm="3" cols="12">
                  <v-card
                    class="mx-auto"
                    max-width="400"
                    outlined
                    @click="footerOnClick"
                  >
                    <v-list-item two-line>
                      <v-list-item-avatar tile>
                        <v-sheet
                          :color="footer"
                          elevation="0"
                          height="100"
                          width="100"
                        ></v-sheet>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          class="font-weight-bold text-uppercase"
                          >{{
                            $vuetify.lang.t('$vuetify.company.footerColor')
                          }}</v-list-item-title
                        >
                        <v-list-item-subtitle>{{
                          showFooterColor
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-col>
                <v-col lg="3" md="3" sm="3" cols="12">
                  <v-card
                    class="mx-auto"
                    max-width="400"
                    outlined
                    @click="buttonOnClick"
                  >
                    <v-list-item two-line>
                      <v-list-item-avatar tile>
                        <v-sheet
                          :color="button"
                          elevation="0"
                          height="100"
                          width="100"
                        ></v-sheet>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          class="font-weight-bold text-uppercase"
                          >{{
                            $vuetify.lang.t('$vuetify.company.buttonColor')
                          }}</v-list-item-title
                        >
                        <v-list-item-subtitle>{{
                          showButtonColor
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-col>
              </v-row>
              <v-row class="px-3">
                <v-col cols="12">
                  <p class="title font-weight-black mb-0">
                    {{ $vuetify.lang.t('$vuetify.company.preview') }}
                  </p>
                  <!-- header -->
                  <v-sheet
                    :color="header"
                    elevation="0"
                    height="20"
                    width="100%"
                  ></v-sheet>
                  <!-- header -->
                  <!-- toolbar -->
                  <v-sheet
                    class="py-5 pl-5"
                    color="white"
                    elevation="2"
                    height="50"
                    width="100%"
                  >
                    <v-sheet
                      color="grey lighten-3"
                      elevation="0"
                      height="15"
                      width="200"
                    ></v-sheet>
                  </v-sheet>
                  <!-- toobar -->
                  <!-- body -->
                  <v-sheet
                    class="px-15 py-10"
                    color="white"
                    elevation="2"
                    height="500"
                    width="100%"
                  >
                    <v-row class="mx-15">
                      <v-col cols="8" class="ma-auto">
                        <v-sheet
                          color="grey lighten-3"
                          elevation="0"
                          height="15"
                          width="250"
                        ></v-sheet>
                      </v-col>
                      <v-col
                        cols="4"
                        class="d-flex"
                        style="justify-content: flex-end"
                      >
                        <v-btn text :color="button">
                          {{ $vuetify.lang.t('$vuetify.company.seemore') }}
                          <v-icon right small>mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row class="mx-15">
                      <v-col cols="2">
                        <v-avatar class="mb-2" :color="overall" size="56"
                          ><v-icon large color="white" class="mt-2">
                            mdi-cursor-default-click
                          </v-icon></v-avatar
                        >

                        <v-sheet
                          :color="overall"
                          elevation="0"
                          height="10"
                          width="60"
                        ></v-sheet>
                      </v-col>
                      <v-col cols="2">
                        <v-avatar
                          class="mb-2"
                          color="grey lighten-3"
                          size="56"
                        ></v-avatar>
                        <v-sheet
                          color="grey lighten-3"
                          elevation="0"
                          height="10"
                          width="60"
                        ></v-sheet>
                      </v-col>
                      <v-col cols="2">
                        <v-avatar
                          class="mb-2"
                          color="grey lighten-3"
                          size="56"
                        ></v-avatar>
                        <v-sheet
                          color="grey lighten-3"
                          elevation="0"
                          height="10"
                          width="60"
                        ></v-sheet>
                      </v-col>
                      <v-col cols="2">
                        <v-avatar
                          class="mb-2"
                          color="grey lighten-3"
                          size="56"
                        ></v-avatar>
                        <v-sheet
                          color="grey lighten-3"
                          elevation="0"
                          height="10"
                          width="60"
                        ></v-sheet>
                      </v-col>
                      <v-col cols="2">
                        <v-avatar
                          class="mb-2"
                          color="grey lighten-3"
                          size="56"
                        ></v-avatar>
                        <v-sheet
                          color="grey lighten-3"
                          elevation="0"
                          height="10"
                          width="60"
                        ></v-sheet>
                      </v-col>
                      <v-col cols="2">
                        <v-avatar
                          class="mb-2"
                          color="grey lighten-3"
                          size="56"
                        ></v-avatar>
                        <v-sheet
                          color="grey lighten-3"
                          elevation="0"
                          height="10"
                          width="60"
                        ></v-sheet>
                      </v-col>
                    </v-row>
                    <v-row class="mx-15">
                      <v-col cols="8" class="ma-auto">
                        <v-sheet
                          color="grey lighten-3"
                          elevation="0"
                          height="15"
                          width="250"
                        ></v-sheet>
                      </v-col>
                      <v-col
                        cols="4"
                        class="d-flex"
                        style="justify-content: flex-end"
                      >
                        <v-btn text :color="button">
                          {{ $vuetify.lang.t('$vuetify.company.seemore') }}
                          <v-icon right small>mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row class="mx-15">
                      <v-col cols="3">
                        <v-sheet
                          class="my-2"
                          color="grey lighten-3"
                          elevation="0"
                          height="100"
                          width="100"
                        ></v-sheet>
                        <v-sheet
                          class="mb-2"
                          :color="overall"
                          elevation="0"
                          height="10"
                          width="70"
                        ></v-sheet>
                        <v-sheet
                          color="grey lighten-3"
                          elevation="0"
                          height="10"
                          width="100"
                        ></v-sheet>
                        <v-row>
                          <v-col cols="2" class="py-0 pr-0"
                            ><v-icon :color="overall" small>
                              mdi-star
                            </v-icon></v-col
                          >
                          <v-col cols="10" class="py-0 pl-0 my-auto">
                            <v-sheet
                              :color="overall"
                              elevation="0"
                              height="8"
                              width="30"
                            ></v-sheet>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="3">
                        <v-sheet
                          class="my-2"
                          color="grey lighten-3"
                          elevation="0"
                          height="100"
                          width="100"
                        ></v-sheet>
                        <v-sheet
                          class="mb-2"
                          :color="overall"
                          elevation="0"
                          height="10"
                          width="70"
                        ></v-sheet>
                        <v-sheet
                          color="grey lighten-3"
                          elevation="0"
                          height="10"
                          width="100"
                        ></v-sheet>
                        <v-row>
                          <v-col cols="2" class="py-0 pr-0"
                            ><v-icon :color="overall" small>
                              mdi-star
                            </v-icon></v-col
                          >
                          <v-col cols="10" class="py-0 pl-0 my-auto">
                            <v-sheet
                              :color="overall"
                              elevation="0"
                              height="8"
                              width="30"
                            ></v-sheet>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="3">
                        <v-sheet
                          class="my-2"
                          color="grey lighten-3"
                          elevation="0"
                          height="100"
                          width="100"
                        ></v-sheet>
                        <v-sheet
                          class="mb-2"
                          :color="overall"
                          elevation="0"
                          height="10"
                          width="70"
                        ></v-sheet>
                        <v-sheet
                          color="grey lighten-3"
                          elevation="0"
                          height="10"
                          width="100"
                        ></v-sheet>
                        <v-row>
                          <v-col cols="2" class="py-0 pr-0"
                            ><v-icon :color="overall" small>
                              mdi-star
                            </v-icon></v-col
                          >
                          <v-col cols="10" class="py-0 pl-0 my-auto">
                            <v-sheet
                              :color="overall"
                              elevation="0"
                              height="8"
                              width="30"
                            ></v-sheet>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="3">
                        <v-sheet
                          class="my-2"
                          color="grey lighten-3"
                          elevation="0"
                          height="100"
                          width="100"
                        ></v-sheet>
                        <v-sheet
                          class="mb-2"
                          :color="overall"
                          elevation="0"
                          height="10"
                          width="70"
                        ></v-sheet>
                        <v-sheet
                          color="grey lighten-3"
                          elevation="0"
                          height="10"
                          width="100"
                        ></v-sheet>
                        <v-row>
                          <v-col cols="2" class="py-0 pr-0"
                            ><v-icon :color="overall" small>
                              mdi-star
                            </v-icon></v-col
                          >
                          <v-col cols="10" class="py-0 pl-0 my-auto">
                            <v-sheet
                              :color="overall"
                              elevation="0"
                              height="8"
                              width="30"
                            ></v-sheet>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-sheet>
                  <!-- body -->
                  <!-- footer -->
                  <v-sheet
                    class="px-15 py-3"
                    :color="footer"
                    elevation="0"
                    height="100"
                    width="100%"
                  >
                    <v-row class="mx-15">
                      <v-col cols="4">
                        <v-sheet
                          class="mb-2"
                          color="grey lighten-3"
                          elevation="0"
                          height="15"
                          width="200"
                        ></v-sheet>
                        <v-sheet
                          class="mb-2"
                          color="grey lighten-2"
                          elevation="0"
                          height="10"
                          width="150"
                        ></v-sheet>
                        <v-sheet
                          class="mb-2"
                          color="grey lighten-2"
                          elevation="0"
                          height="10"
                          width="100"
                        ></v-sheet>
                      </v-col>
                      <v-col cols="4">
                        <v-sheet
                          class="mb-2"
                          color="grey lighten-3"
                          elevation="0"
                          height="15"
                          width="200"
                        ></v-sheet>
                        <v-sheet
                          class="mb-2"
                          color="grey lighten-2"
                          elevation="0"
                          height="10"
                          width="150"
                        ></v-sheet>
                        <v-sheet
                          class="mb-2"
                          color="grey lighten-2"
                          elevation="0"
                          height="10"
                          width="100"
                        ></v-sheet>
                      </v-col>
                      <v-col cols="4">
                        <v-sheet
                          class="mb-2"
                          color="grey lighten-3"
                          elevation="0"
                          height="15"
                          width="200"
                        ></v-sheet>
                        <v-sheet
                          class="mb-2"
                          color="grey lighten-2"
                          elevation="0"
                          height="10"
                          width="150"
                        ></v-sheet>
                        <v-sheet
                          class="mb-2"
                          color="grey lighten-2"
                          elevation="0"
                          height="10"
                          width="100"
                        ></v-sheet>
                      </v-col>
                    </v-row>
                  </v-sheet>
                  <!-- footer -->
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- <warnningComponent
        v-bind:textInfo.sync="textWarning"
        v-bind:typestatus.sync="typeWarning"
        v-bind:alert.sync="showWarnnig"
      ></warnningComponent> -->
      <v-row>
        <v-col>
          <div class="my-2 float-right">
            <v-btn
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              @click="onCancle"
              outlined
              dark
              large
              >{{ $vuetify.lang.t('$vuetify.company.cancel') }}</v-btn
            >
            <v-btn
              class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
              :disabled="!valid || loadingbtn || !validationForm()"
              :loading="loadingbtn"
              large
              @click="onUpload"
              >{{ $vuetify.lang.t('$vuetify.company.save') }}</v-btn
            >
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-dialog v-model="invalidFormDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="font-weight-light">{{
              $vuetify.lang.t('$vuetify.company.saveFailed')
            }}</v-card-title>
            <v-spacer></v-spacer>
            <v-card-text>
              <v-col class="py-0 my-0">
                <p class="font-weight-light">
                  {{ $vuetify.lang.t('$vuetify.company.msg9') }}
                </p>
              </v-col>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary darken-1"
                text
                @click="invalidFormDialog = false"
                >{{ $vuetify.lang.t('$vuetify.company.ok') }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row>
        <v-dialog v-model="duplicateDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">{{
              $vuetify.lang.t('$vuetify.company.saveFailed')
            }}</v-card-title>
            <v-card-text>{{
              $vuetify.lang.t('$vuetify.company.msg8')
            }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary darken-1"
                text
                @click="duplicateDialog = false"
                >{{ $vuetify.lang.t('$vuetify.company.ok') }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <!--color dialog-->
      <v-dialog persistent v-model="headerDialog" max-width="350">
        <v-card>
          <v-card-title class="font-weight-light">{{
            $vuetify.lang.t('$vuetify.company.headerColor')
          }}</v-card-title>

          <v-card-text class="pa-5">
            <v-color-picker
              v-model="header"
              show-swatches
              :mode.sync="mode"
            ></v-color-picker>
            <v-select
              v-model="mode"
              :items="colorPickerModes"
              style="max-width: 300px"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              outlined
              dark
              @click.stop="headerOnCancel"
              >{{ $vuetify.lang.t('$vuetify.company.cancel') }}</v-btn
            >

            <v-btn
              class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
              @click="headerDialog = false"
              >{{ $vuetify.lang.t('$vuetify.company.done') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="overallDialog" max-width="350">
        <v-card>
          <v-card-title class="font-weight-light">{{
            $vuetify.lang.t('$vuetify.company.themeColor')
          }}</v-card-title>

          <v-card-text class="pa-5">
            <v-color-picker
              v-model="overall"
              show-swatches
              :mode.sync="mode"
            ></v-color-picker>
            <v-select
              v-model="mode"
              :items="colorPickerModes"
              style="max-width: 300px"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              outlined
              dark
              @click="overallOnCancel"
              >{{ $vuetify.lang.t('$vuetify.company.cancel') }}</v-btn
            >

            <v-btn
              class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
              @click="overallDialog = false"
              >{{ $vuetify.lang.t('$vuetify.company.done') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="buttonDialog" max-width="350">
        <v-card>
          <v-card-title class="font-weight-light">{{
            $vuetify.lang.t('$vuetify.company.buttonColor')
          }}</v-card-title>

          <v-card-text class="pa-5">
            <v-color-picker
              v-model="button"
              show-swatches
              :mode.sync="mode"
            ></v-color-picker>
            <v-select
              v-model="mode"
              :items="colorPickerModes"
              style="max-width: 300px"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              outlined
              dark
              @click="buttonOnCancel"
              >{{ $vuetify.lang.t('$vuetify.company.cancel') }}</v-btn
            >

            <v-btn
              class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
              @click="buttonDialog = false"
              >{{ $vuetify.lang.t('$vuetify.company.done') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="footerDialog" max-width="350">
        <v-card>
          <v-card-title class="font-weight-light">{{
            $vuetify.lang.t('$vuetify.company.footerColor')
          }}</v-card-title>

          <v-card-text class="pa-5">
            <v-color-picker
              v-model="footer"
              show-swatches
              :mode.sync="mode"
            ></v-color-picker>
            <v-select
              v-model="mode"
              :items="colorPickerModes"
              style="max-width: 300px"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              outlined
              dark
              @click="footerOnCancel"
              >{{ $vuetify.lang.t('$vuetify.company.cancel') }}</v-btn
            >

            <v-btn
              class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
              @click="footerDialog = false"
              >{{ $vuetify.lang.t('$vuetify.company.done') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogUpdateSuccess" max-width="500">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t('$vuetify.companyManagement.updateSuccess')
          }}</v-card-title>

          <v-card-text>{{
            $vuetify.lang.t('$vuetify.companyManagement.updateInfoSuccess')
          }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click="dialogUpdateSuccess = false"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.liveStep.addLiveDialog.done'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="alert" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t('$vuetify.courseManagement.courseList.sorry')
          }}</v-card-title>
          <v-card-text>
            <div
              v-html="
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseList.alertPermissionFunction'
                )
              "
            ></div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="alert = false">{{
              $vuetify.lang.t('$vuetify.courseManagement.courseList.ok')
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="fileTooLargeDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t('$vuetify.company.errorTitleFileTooLarge')
          }}</v-card-title>
          <v-card-text>
            <div>
              {{ $vuetify.lang.t('$vuetify.company.errorMsgFileTooLarge') }}
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              text
              @click="fileTooLargeDialog = false"
              >{{ $vuetify.lang.t('$vuetify.company.ok') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="fileTooLargeDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t('$vuetify.company.errorTitleFileTooLarge')
          }}</v-card-title>
          <v-card-text>
            <div>
              {{ $vuetify.lang.t('$vuetify.company.errorMsgFileTooLarge') }}
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              text
              @click="fileTooLargeDialog = false"
              >{{ $vuetify.lang.t('$vuetify.company.ok') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="fileNotImageDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t('$vuetify.company.errorTitleFileNotImage')
          }}</v-card-title>
          <v-card-text>
            <div>
              {{ $vuetify.lang.t('$vuetify.company.errorMsgFileNotImage') }}
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              text
              @click="fileNotImageDialog = false"
              >{{ $vuetify.lang.t('$vuetify.company.ok') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import { uploadImage } from '@/service/upload/upload';
import { cleaningData } from '@/helper/cleaningData';
import { updateCompanyAdCom, getCompanyByID } from '@/service/company/company';
import warnningComponent from '../../components/warningAlert.vue';

export default {
  components: {
    // warnningComponent,
  },
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return {
      isShow: false,
      invalidFormDialog: false,

      mode: 'hsla',
      colorPickerModes: ['hsla', 'rgba', 'hexa'],
      idcompany: '',
      valid: true,
      title: '',
      description: '',
      systemEmail: '',
      contactEmail: '',
      domainName: '',
      password: '',
      logo: '',
      coverImg: '',
      keyIcon: '',
      headerColor: '#607D8B',
      footerColor: '#607D8B',
      buttonColor: '#607D8B',
      themeColor: '#607D8B',

      passwordRules: [(v) => !!v || 'Password is required'],
      companyNameRules: [(v) => !!v || 'Company Name  is required'],
      descriptionRules: [(v) => !!v || "Company's Description is required"],
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      keyIconRules: [(v) => !!v || 'Key Icon is required'],
      domainNameRule: [(v) => !!v || 'Sub Domain Name is required'],
      imageRules: [
        (v) =>
          !v ||
          v.size < 3 * 1024 * -1024 ||
          'Image size should be less than 3 MB!',
      ],
      // colorRules: [v => !!v || "Color  is required"],

      tmpLogo: '',
      tmpCoverImg: '',

      imgURL: '',
      logoFile: null,
      coverImgFile: null,
      logoReady: false,
      coverImgReady: false,

      headerDialog: false,
      footerDialog: false,
      buttonDialog: false,
      overallDialog: false,
      duplicateDialog: false,
      tmpColor: '#607D8B',

      externalAccess: false,
      company_info: [],
      params: {
        idcompany: '',
      },

      //cover img
      imageFile: null,
      logo_url: '',
      cover_url: '',

      //warrning
      textWarning: '',
      typeWarning: '',
      showWarnnig: false,

      //limitaion
      canRegister: false,
      loginGoogle: false,
      loginAppleID: false,
      loginFacebook: false,
      loginEmail: false,

      dialogUpdateSuccess: false,
      fileTooLargeDialog: false,
      fileNotImageDialog: false,

      alert: false,
      loadingbtn: false,
    };
  },
  beforeMount() {
    if (!this.$store.state.permission.adminCompany) {
      this.noPermission();
    }
  },
  mounted() {
    console.log(this.id);
    this.initialize();
  },
  computed: {
    header: {
      get() {
        return this.headerColor;
      },
      set(v) {
        this.headerColor = v;
      },
    },
    footer: {
      get() {
        return this.footerColor;
      },
      set(v) {
        this.footerColor = v;
      },
    },
    button: {
      get() {
        return this.buttonColor;
      },
      set(v) {
        this.buttonColor = v;
      },
    },
    overall: {
      get() {
        return this.themeColor;
      },
      set(v) {
        this.themeColor = v;
      },
    },
    showHeaderColor() {
      if (typeof this.header === 'string') return this.header;

      return JSON.stringify(
        Object.keys(this.header).reduce((header, key) => {
          header[key] = Number(this.header[key].toFixed(2));
          return header;
        }, {}),
        null,
        2
      );
    },
    showFooterColor() {
      if (typeof this.footer === 'string') return this.footer;

      return JSON.stringify(
        Object.keys(this.footer).reduce((footer, key) => {
          footer[key] = Number(this.footer[key].toFixed(2));
          return footer;
        }, {}),
        null,
        2
      );
    },
    showButtonColor() {
      if (typeof this.button === 'string') return this.button;

      return JSON.stringify(
        Object.keys(this.button).reduce((button, key) => {
          button[key] = Number(this.button[key].toFixed(2));
          return button;
        }, {}),
        null,
        2
      );
    },
    showOverallColor() {
      if (typeof this.overall === 'string') return this.overall;

      return JSON.stringify(
        Object.keys(this.overall).reduce((overall, key) => {
          overall[key] = Number(this.overall[key].toFixed(2));
          return overall;
        }, {}),
        null,
        2
      );
    },

    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter((key) => key !== `Name`);
    },
  },
  watch: {
    id(value) {
      if (value) {
        console.log(value);
        this.idcompany = value;
        this.initialize();
      }
    },
    canRegister: async function (newValue) {
      if (newValue === false) {
        this.loginGoogle = false;
        this.loginAppleID = false;
        this.loginFacebook = false;
        this.loginEmail = false;
      } else if (newValue === true) {
        this.loginEmail = true;
        this.loginGoogle = true;
        this.loginAppleID = true;
        this.loginFacebook = true;
      }
    },
  },
  methods: {
    noPermission() {
      // console.log("no permission");
      this.alert = true;
    },
    async initialize() {
      console.log(this.idcompany);
      let params = {
        idcompany: this.idcompany,
      };
      this.company_info = await getCompanyByID(params);
      this.title = this.company_info.company.title;
      this.description = this.company_info.company.description;
      this.systemEmail = this.company_info.company.systemEmail;
      this.contactEmail = this.company_info.company.contactEmail
        ? this.company_info.company.contactEmail
        : '';
      this.externalAccess = this.company_info.company.externalAccess;
      this.logo = this.company_info.company.logo;
      this.keyIcon = this.company_info.company.keyIcon
        ? this.company_info.company.keyIcon
        : '';
      this.coverImg = this.company_info.company.coverImg;
      this.domainName = this.company_info.company.domainName
        ? this.company_info.company.domainName
        : '';
      this.headerColor = this.company_info.company.headerColor
        ? this.company_info.company.headerColor
        : '#607D8B';
      this.footerColor = this.company_info.company.footerColor
        ? this.company_info.company.footerColor
        : '#607D8B';
      this.buttonColor = this.company_info.company.buttonColor
        ? this.company_info.company.buttonColor
        : '#607D8B';
      this.themeColor = this.company_info.company.themeColor
        ? this.company_info.company.themeColor
        : '#607D8B';

      //limitation
      this.canRegister = this.company_info.company.canRegister ? true : false;
      this.loginGoogle = this.company_info.company.loginGoogle
        ? this.company_info.company.loginGoogle
        : false;
      this.loginAppleID = this.company_info.company.loginAppleID
        ? this.company_info.company.loginAppleID
        : false;
      this.loginFacebook = this.company_info.company.loginFacebook
        ? this.company_info.company.loginFacebook
        : false;
      this.loginEmail = this.company_info.company.loginEmail
        ? this.company_info.company.loginEmail
        : false;

      if (this.coverImg != undefined) {
        this.coverImgReady = true;
      }

      if (this.logo != undefined) {
        this.logoReady = true;
      }
    },
    validationForm() {
      let bool = true;
      if (this.title.length == 0) {
        bool = false;
      }
      if (this.contactEmail.length == 0) {
        bool = false;
      }
      if (this.domainName.length == 0) {
        bool = false;
      }
      if (!this.logo || !this.coverImg) {
        bool = false;
      }
      return bool;
    },
    async onUpload() {
      if (this.$refs.form.validate()) {
        this.loadingbtn = true;
        Promise.all([
          (this.logo_url =
            this.logoFile !== null
              ? await this.uploadImg(this.logoFile)
              : this.logo),
          (this.cover_url =
            this.imageFile !== null
              ? await this.uploadImg(this.imageFile)
              : this.coverImg),
        ]);
        this.logo = this.logo_url;
        this.coverImg = this.cover_url;

        let isValidForm = true;

        if (this.logo.length > 1) {
          console.log('COMPANY LOGO:');
        } else {
          isValidForm = false;
          console.log('COPANY LOGO ERROR');
        }

        if (this.coverImg.length > 1) {
          console.log(this.coverImg);
          console.log('COVER IMAGE:');
        } else {
          isValidForm = false;
          console.log('COVER IMAGE ERROR');
        }

        if (this.headerColor.length > 1) {
          console.log('HEADER COLOR:');
        } else {
          isValidForm = false;
          console.log('HEADER COLOR ERROR');
        }
        if (this.footerColor.length > 1) {
          console.log('FOOTER COLOR:');
        } else {
          isValidForm = false;
          console.log('FOOTER COLOR ERROR');
        }
        if (this.buttonColor.length > 1) {
          console.log('BUTTON COLOR:');
        } else {
          isValidForm = false;
          console.log('BUTTON COLOR ERROR');
        }

        if (this.themeColor.length > 1) {
          console.log('OVERALL COLOR:', this.themeColor);
        } else {
          isValidForm = false;
          console.log('OVERALL COLOR ERROR');
        }

        if (isValidForm) {
          let updateStatus = await this.updateCompanyAdCom();
          console.log('UPDATE COMPANY STATUS', updateStatus);
        } else {
          this.invalidFormDialog = true;
        }

        this.loadingbtn = false;
      }
    },

    async updateCompanyAdCom() {
      let status = await updateCompanyAdCom({
        id: this.id,
        title: cleaningData(this.title),
        description: this.description,
        systemEmail: this.systemEmail,
        externalAccess: this.externalAccess,
        contactEmail: this.contactEmail,
        logo: this.logo,
        keyIcon: this.keyIcon,
        coverImg: this.coverImg,
        headerColor: this.headerColor,
        footerColor: this.footerColor,
        buttonColor: this.buttonColor,
        themeColor: this.themeColor,
        domainName: this.domainName,
        canRegister: this.canRegister,
        loginGoogle: this.loginGoogle,
        loginAppleID: this.loginAppleID,
        loginFacebook: this.loginFacebook,
        loginEmail: this.loginEmail,
      });
      if (status.message == 'domain duplicate') {
        this.duplicateDialog = true;
        // this.warnnig('Domain duplicate', 'warning');
      } else if (status.code == 403) {
        this.invalidFormDialog = true;
        // this.warnnig('กรุณากรอกข้อมูลให้ถูกต้อง', 'warning');
      } else {
        this.dialogUpdateSuccess = true;
      }
    },

    // External Access
    async previewLogo(event) {
      let file = event.target.files[0];
      console.log(file);

      if (file.type != 'image/jpeg' && file.type != 'image/png') {
        this.fileNotImageDialog = true;
        return;
      }

      if (file.size > 3 * 1024 * 1024) {
        this.fileTooLargeDialog = true;
        return;
      }

      this.logoFile = file;
      this.logo = URL.createObjectURL(file);

      this.logoReady = true;
    },

    async previewCoverImg(event) {
      let file = event.target.files[0];
      console.log(file);

      if (file.type != 'image/jpeg' && file.type != 'image/png') {
        this.fileNotImageDialog = true;
        return;
      }

      if (file.size > 3 * 1024 * 1024) {
        this.fileTooLargeDialog = true;
        return;
      }

      this.imageFile = file;
      this.coverImg = URL.createObjectURL(file);
      this.coverImgReady = true;
    },

    async uploadImg(image) {
      let status = await uploadImage('company', image);
      return status;
    },
    onCancle() {
      this.initialize();
    },

    initData() {
      this.title = '';
      this.description = '';
      this.systemEmail = '';
      this.contactEmail = '';
      this.password = '';
      this.externalAccess = '';
      this.logo = '';
      this.keyIcon = '';
      this.cover = '';
      this.domainName = '';
      this.headerColor = '#607D8B';
      this.footerColor = '#607D8B';
      this.buttonColor = '#607D8B';
      this.themeColor = '#607D8B';
      this.canRegister = false;
      this.canRegister = false;
      this.loginGoogle = false;
      this.loginAppleID = false;
      this.loginFacebook = false;
      this.loginEmail = false;
    },

    headerOnClick() {
      this.tmpColor = this.header;
      this.headerDialog = true;
    },
    headerOnCancel() {
      this.headerColor = this.tmpColor;
      this.headerDialog = false;
    },
    footerOnClick() {
      this.tmpColor = this.footer;
      this.footerDialog = true;
    },
    footerOnCancel() {
      this.footerColor = this.tmpColor;
      this.footerDialog = false;
    },
    buttonOnClick() {
      this.tmpColor = this.button;
      this.buttonDialog = true;
    },
    buttonOnCancel() {
      this.buttonColor = this.tmpColor;
      this.buttonDialog = false;
    },
    overallOnClick() {
      this.tmpColor = this.overall;
      this.overallDialog = true;
    },
    overallOnCancel() {
      this.themeColor = this.tmpColor;
      this.overallDialog = false;
    },
    warnnig(text, type) {
      (this.textWarning = text),
        (this.typeWarning = type),
        (this.showWarnnig = true);
      setInterval(() => {
        this.showWarnnig = false;
      }, 5000);
    },
  },
};
</script>

<style scoped>
.col-style {
  display: flex;
  justify-content: center;
}
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}

.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.text-right {
  text-align: right;
}

.editor {
  /* height: 200px;
  margin-bottom: 70px; */
  background: #fff;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  align-self: center;
  position: absolute;
  opacity: 0.5;
  height: 20%;
  width: 100%;
}
.border-card {
  border: 1px dashed #80808040 !important;
  /* -webkit-box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)!important; */
  /* box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)!important; */
}
.image-preview {
  height: 90px;
  border: 1px dashed rgba(0, 0, 0, 0.15) !important;
  background: #ebedf0;
  width: 200px !important;
}
.image-preview-logo {
  height: 120px;
  border: 1px dashed rgba(0, 0, 0, 0.15) !important;
  background: #ebedf0;
  width: 120px !important;
}

/*btn-upload image*/
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 170px !important;
}

.btn-choose {
  color: rgba(0, 0, 0, 0.65);
  background-color: white;
  padding: 8px 20px;
  font-size: 16px;
  width: 170px !important;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}

.upload-btn-wrapper input[type='file'] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.upload-btn-wrapper input[type='file']:hover {
  cursor: pointer;
}
</style>
<style>
.v-text-field--enclosed .v-input__append-inner {
  margin-top: 5px !important;
}
.input-number {
  height: 45px !important;
}

.input-number > .v-input__control > .v-input__slot {
  min-height: 45px !important;
}

.input-number
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  > input {
  text-align: right;
}
.editor {
  /*min-height: 250px;
   margin-bottom: 70px;*/
  background: #fff;
}
.detail-editor {
  border-radius: 4px;
}

.detail-editor .ql-container {
  min-height: 175px !important;
}
.ql-container.ql-snow {
  border: 1px solid #e0e0e0;
  border-radius: 0 0 4px 4px;
}
.ql-toolbar.ql-snow {
  border: 1px solid #e0e0e0;
  border-radius: 4px 4px 0 0;
}
</style>
